/* ============================================================
   Two Waves — lightweight video loader (pairs with snippets/tw-video.liquid)
   Videos ship with a poster only. A clip gets its src when it comes near
   the viewport, plays while visible and pauses when it leaves, so a page
   never downloads clips the visitor doesn't scroll to.
   Phones (< 750px) get the small rendition, larger screens the bigger one.
   Reduced motion, Save-Data and in-app browsers (see layout tw-inapp-video)
   keep the poster: nothing autoplays there.
   ============================================================ */
(function () {
  'use strict';

  function pick(v) {
    var small = window.matchMedia('(max-width: 749px)').matches;
    return (small ? v.getAttribute('data-src-sm') : v.getAttribute('data-src-lg')) ||
      v.getAttribute('data-src-lg') || v.getAttribute('data-src-sm') || '';
  }

  function load(v) {
    if (!v || v.getAttribute('data-tw-loaded')) return;
    var src = pick(v);
    if (!src) return;
    v.setAttribute('data-tw-loaded', '1');
    v.src = src;
  }

  function play(v) {
    load(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Public helpers so other scripts (PDP gallery) can drive manual videos.
  window.TWVideo = { load: load, play: play };

  // The 480p/720p URLs are derived from the 1080p one (see tw-video.liquid).
  // If one ever fails to load, fall back once to the original file.
  // Media 'error' events don't bubble, but a capturing listener still sees them.
  document.addEventListener('error', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !v.hasAttribute('data-tw-video')) return;
    var full = v.getAttribute('data-src-full');
    if (!full || v.getAttribute('data-tw-fallback') || v.currentSrc.indexOf(full) !== -1) return;
    v.setAttribute('data-tw-fallback', '1');
    var wasPlaying = v.getAttribute('data-tw-loaded');
    v.src = full;
    if (wasPlaying) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }, true);

  // Posters of clips further down the page (reels, section backgrounds) ship as
  // data-poster so they don't compete with the main photo while the page loads.
  // They get their poster as they approach the viewport, for every visitor
  // (in-app browsers and reduced motion included: there the poster is all they see).
  var lazyPosters = document.querySelectorAll('video[data-poster]:not([data-tw-video-manual])');
  function showPoster(v) {
    if (!v.getAttribute('data-poster')) return;
    v.setAttribute('poster', v.getAttribute('data-poster'));
    v.removeAttribute('data-poster');
  }
  if (lazyPosters.length) {
    if ('IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          // Siblings in a horizontal strip (reels) are clipped by their scroller,
          // so give the whole section its posters at once.
          var group = e.target.closest('section') || e.target;
          group.querySelectorAll('video[data-poster]').forEach(function (v) {
            if (v.hasAttribute('data-tw-video-manual')) return;
            showPoster(v);
            pio.unobserve(v);
          });
        });
      }, { rootMargin: '800px 0px' });
      lazyPosters.forEach(function (v) { pio.observe(v); });
    } else {
      lazyPosters.forEach(showPoster);
    }
  }

  var videos = document.querySelectorAll('video[data-tw-video]:not([data-tw-video-manual])');
  if (!videos.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData || window.TW_INAPP) return;

  if (!('IntersectionObserver' in window)) {
    videos.forEach(play);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        play(v);
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.01 });

  // Start only once the page has finished loading (plus a short idle pause), so a
  // clip near the top never competes with the main photo, fonts and CSS on a
  // phone connection. Until then the poster shows, which looks the same.
  function start() {
    videos.forEach(function (v) { io.observe(v); });
  }
  function startWhenIdle() {
    var go = function () { setTimeout(start, 1200); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(go, { timeout: 3000 });
    } else {
      go();
    }
  }
  if (document.readyState === 'complete') {
    startWhenIdle();
  } else {
    window.addEventListener('load', startWhenIdle, { once: true });
  }

  // Browsers pause offscreen media when the tab is hidden; resume visible ones.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    videos.forEach(function (v) {
      if (!v.getAttribute('data-tw-loaded')) return;
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  });
})();
